import { inject, Injectable } from '@angular/core';

import { AuthService, LoggingService } from '@ld.consumer-portal/utils';
import { SsoAuthService, SsoLoginResponse } from './sso-auth.service';

@Injectable({
  providedIn: 'root',
})
export class OriginationAuthService {
  private readonly authService = inject(AuthService);
  private readonly ssoAuthService = inject(SsoAuthService);
  private readonly loggingService = inject(LoggingService);

  async refreshCpToken(): Promise<SsoLoginResponse | null> {
    try {
      const response = await this.ssoAuthService.refresh();

      this.authService.setCpContext({
        authToken: response.authToken,
        loanId: response.loanId,
        borrowerId: response.borrowerId,
        userGuid: response.userGuid,
        expiresInSeconds: response.expiresInSeconds,
        visitorId: response.visitorId,
        mlaDomainLink: response.mlaDomainLink,
        email: response.email,
      });

      return response;
    } catch (error) {
      this.loggingService.logException(error, 'CP token refresh failed:');
      return null;
    }
  }

  logout(): void {
    this.authService.clearAllTokens();
  }
}
